import TermsHtml from './TermsHtml';

export default TermsHtml;
